import { memo, useReducer, useState } from 'react'
import { Theme, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import Notice, { NoticeType } from 'components/Notice'
import { useText } from 'stores/utils/hooks/useText'
import { useStores } from 'stores/utils/hooks/useStores'
import isNotAffiliate from 'utils/formDependencies/conditions/isNotAffiliate'
import useEmotionStyles from 'hooks/useEmotionStyles'

const styles = (theme: Theme) => ({
  container: {
    borderLeft: `2px solid ${theme.palette.primary.main}`
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.25rem'
  },
  button: {
    border: 'none',
    margin: 0,
    backgroundColor: 'transparent',
    cursor: 'default',
    color: theme.palette.primary.main
  },
  confirmButton: {
    border: 'none',
    margin: 0,
    padding: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',

    '& p': {
      color: theme.palette.grey[700],
      fontWeight: 700
    }
  },
  textBlock: {
    lineHeight: 1,
    marginBottom: theme.spacing(1),
    color: `${theme.palette.grey[900]} !important`
  },
  longTextBlock: {
    lineHeight: 1,
    marginTop: theme.spacing(1),
    color: `${theme.palette.grey[900]} !important`
  }
})

const SchufaBanner = () => {
  const [expanded, toggleExpanded] = useReducer((state) => !state, false)
  const [display, setDisplay] = useState(true)

  const { linkWrapper, button, confirmButton, textBlock, longTextBlock } =
    useEmotionStyles(styles)
  const {
    text: { copy }
  } = useText()

  const {
    navigation: { tenantContext },
    traversal: { data }
  } = useStores()

  if (!display) {
    return null
  }

  const notAffiliate = isNotAffiliate(data, tenantContext)

  return (
    <Notice
      type={NoticeType.SUCCESS_FILLED}
      withSmallerBorderRadius
      withColorFromPalette
    >
      <div className={textBlock}>
        <strong>
          {`Bei ${
            notAffiliate ? 'smava' : 'uns'
          } brauchen Sie sich keine Sorgen bezüglich der Schufa zu
          machen.`}
        </strong>
      </div>
      <div className={textBlock}>
        Das Einholen von Kreditangeboten hat keinen Einfluss auf Ihren
        Schufa-Score.
      </div>
      <button
        type="button"
        className={confirmButton}
        onClick={() => setDisplay(false)}
      >
        <Typography variant="body1">Verstanden</Typography>
      </button>
      <button type="button" className={button} onClick={toggleExpanded}>
        <div className={linkWrapper}>
          Mehr erfahren
          {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </div>
      </button>
      {expanded && (
        <div className={longTextBlock}>
          {`${copy?.introduction?.schufaNeutral?.value}`}
        </div>
      )}
    </Notice>
  )
}

export default memo(SchufaBanner)
